import { TBeaconEntry, DeviceType } from '@ixicare/resources';
import { BEACON_COLUMNS, BEACON_COLUMN_IDS, transformBeaconToRow } from '../rowTransformers';
import { BaseTableConfig, CsvAccessor, WithColumnManager, WithExport, WithTransformer } from '../types';
import { beaconSortAccessors } from './sortAccessors';
import { formatDate } from '@ixicare/ui';

const lastSeenCsvAccessor: CsvAccessor<TBeaconEntry> = (b) => (b.lastSeen ? formatDate(b.lastSeen) : null);

export const beaconTableConfig: BaseTableConfig &
  WithTransformer<TBeaconEntry> &
  WithColumnManager<TBeaconEntry> &
  WithExport<TBeaconEntry> = {
  tableId: 'beacons',
  rowsSelectable: true,
  deviceTypes: [DeviceType.BEACON],
  columns: BEACON_COLUMNS,
  columnIds: BEACON_COLUMN_IDS,
  transformRow: transformBeaconToRow,
  sortAccessors: beaconSortAccessors,
  csvAccessors: { last_seen: lastSeenCsvAccessor },
};
